import { moduleRouteDictionaryFactory } from '@tundr/routing';

export const overBudgetEmployeeRoutesDictionary = moduleRouteDictionaryFactory(
  'overBudgetEmployees',
  'overBudgetEmployees',
  {
    list: 'list',
  },
);
